import { Stack, Text } from '@pairy/pds-react';
import Link from 'next/link';
import { CtaForm, PrivateField } from '@pairy/sheard/types';

import { FormRecordProps } from '../index.type';
import * as Styled from '../index.styles';

interface Props extends FormRecordProps<boolean> {
  title: string;
  description: string;
  ctaField?: CtaForm['fields'];
  template: PrivateField['template'];
}

const PersonalInformation = ({
  id,
  title,
  description,
  handleChangeWithId,
  translateKoToEn,
  value,
  ctaField,
  template,
}: Props) => {
  const requiredFields = ctaField?.filter((field) => field.isRequired);

  const openWindow = () => {
    window.open(template.link, '_blank');
  };

  return (
    <Stack gap={4} direction="column" justifyContent="flex-start">
      <Text variant="sm-semibold" as="label">
        <Stack gap={4} alignItems="center">
          <Styled.MinWidthWrapper width={24} height={24}>
            <Styled.CheckBoxInput
              type="checkbox"
              onChange={() => {
                handleChangeWithId(id, !value);
              }}
              checked={value}
            />
          </Styled.MinWidthWrapper>
          <Styled.MinWidthWrapper width={35}>
            <Text variant="md-semibold" color="skyblue_500">
              ({translateKoToEn('required')})
            </Text>
          </Styled.MinWidthWrapper>
          {template?.type === 'default' ? (
            <Link
              href={{
                pathname: '/personal-information-consent',
                query: {
                  company: template.companyName,
                  content: requiredFields?.map((field) => field.name).join('-'),
                },
              }}
              passHref
            >
              <a target="_blank" rel="noopener noreferrer">
                <Styled.KeepAllText variant="md-semibold">
                  {title}
                </Styled.KeepAllText>
              </a>
            </Link>
          ) : (
            <button onClick={openWindow}>
              <Styled.KeepAllText variant="md-semibold">
                {title}
              </Styled.KeepAllText>
            </button>
          )}
        </Stack>
      </Text>
      <Styled.KeepAllText as="div" variant="sm-medium" color="zinc_400">
        {description}
      </Styled.KeepAllText>
    </Stack>
  );
};

export default PersonalInformation;
